document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-product')) return;

  document.querySelectorAll('.main-product__block-collapsible_tab').forEach(tab => {
    const content = tab.querySelector('.m-collapsible--content__inner');
    if (!content || content.textContent.trim() === '') {
      tab.style.display = 'none';
    }
  });
});
